// extracted by mini-css-extract-plugin
export default {"wrap":"ServerAlarmPushList_wrap__zQOv2","operationArea":"ServerAlarmPushList_operationArea__jCv8r"};